import { GridRowsProp, GridColDef } from '@mui/x-data-grid';
import { Box, Button, Grid, Pagination } from '@mui/material';
import { GLOBAL_CONSTANTS, ROUTES, TOASTER_CONFIGS } from '../../constants';
import { useNavigate, } from 'react-router-dom';
import DataTable from '../../components/DataTable';
import { useDepartmentDeleteMutation, useDepartmentListMutation } from '../../service/apiSlices/accessApiService';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import HttpsIcon from "@mui/icons-material/Https";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { checkEmpty } from '../../utils/helper';


const ManageDepartments = () => {
    const navigate = useNavigate();
    const [listApiCall] = useDepartmentListMutation();
    const [deleteApiCall] = useDepartmentDeleteMutation();
    const [page, setPage] = useState(1);
    const [totalPage, setTotalCount] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(10);
    const [hasProducts, setHasProducts] = useState(false);
    const [DepartmentList, setDepartmentList] = useState([]);

    const rows: GridRowsProp = DepartmentList ?? [];

    const navigateEditValue = (id: any) => {
        navigate(ROUTES.MANAGEDEPARTMENT_add + `/${id}`)
    }

    useEffect(() => {
        GetDepartmentListApiCall();
    }, [page, rowPerPage])

    const GetDepartmentListApiCall = async () => {

        var payload = { page: page, limit: rowPerPage }
        await listApiCall(payload)
            .unwrap()
            .then((response) => {
                setDepartmentList(response?.result?.data);
                setTotalCount(response.result.total_page);
                setHasProducts(checkEmpty(response?.result?.data));
            })
            .catch(() => { })
    }

    const columns: GridColDef[] = [
        { field: 'name', headerName: 'Name', width: 250 },
        {
            field: 'category_icon',
            headerName: 'Icon',
            width: 200,
            renderCell: (params) => (
                <img
                    src={params.value}
                    alt="icon"
                    style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                />
            ),
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 300,
            renderCell: (params) => (
                <>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '15px', alignItems: 'center' }}>
                        <ModeEditIcon onClick={() => navigateEditValue(params.row.id)} style={{ cursor: 'pointer' }} />
                        {params?.row?.is_deleted ? (
                            <div className="reject_btn_wrapper">
                                <div className="accept_btn_label" onClick={() => blockUnblockDeparment(params.row.id, params.row.is_deleted)}>
                                    De-Activated
                                </div>
                                <div className="lock_icon_wrapper">
                                    <HttpsIcon className="lock_icon" />
                                </div>
                            </div>
                        ) : (
                            <div className="accept_btn_wrapper">
                                <div className="unlock_icon_wrapper">
                                    <LockOpenTwoToneIcon className="unlock_icon" />
                                </div>
                                <div className="accept_btn_label" onClick={() => blockUnblockDeparment(params.row.id, params.row.is_deleted)}>
                                    Activated
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ),
        },
    ];


    const blockUnblockDeparment = (id: any, value: any) => {
        deleteApiCall(id)
            .unwrap()
            .then((response) => {
                GetDepartmentListApiCall();
                toast.success(response?.message, TOASTER_CONFIGS);
            })
            .catch((error) => {
                toast.error(error?.data?.message, TOASTER_CONFIGS);
            })

    }

    /**Handle row per page change */
    const onRowChange = (event: any) => {
        setPage(1);
        setRowPerPage(parseInt(event.target.value));
    };

    /* Handle page change */
    const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
        setPage(newPage);
    };


    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                }}
            >
                <Button type="button" variant="contained" onClick={() => navigate(ROUTES.MANAGEDEPARTMENT_add)}
                    sx={{ mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}>
                    Add Category
                </Button>
            </Box>
            <Box>
                <DataTable rows={rows} columns={columns} />
                {hasProducts && (
                    <div className="tablePagination">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={7}>
                                <div className="pagination-wrap">
                                    <Pagination
                                        count={totalPage}
                                        page={page}
                                        onChange={handleChangePage}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <div className="rows-per-page">
                                    <p>Rows per page</p>
                                    <select
                                        className="rows-select"
                                        value={rowPerPage}
                                        onChange={onRowChange}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                )}
            </Box>
        </div >
    )
}

export default ManageDepartments;